<mat-toolbar class="top-nav-toolbar">
  <div class="nav-container">
    <!-- Mobile Hamburger Menu -->
    <button mat-icon-button [matMenuTriggerFor]="categoryMenu" class="hamburger-button" aria-label="Menu">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #categoryMenu="matMenu" class="category-menu">
      @for (nav of navigationCategories(); track nav.id) {
      <button mat-menu-item routerLink="/shop" [queryParams]="{category: nav.categoryName}">
        <span>{{ nav.categoryName | uppercase }}</span>
      </button>
      }
      @if (navigationCategories().length === 0) {
      <button mat-menu-item routerLink="/shop" [queryParams]="{}">
        <span>SHOP</span>
      </button>
      }
      @if (!isAnonymousUser()) {
      <button mat-menu-item routerLink="/order-history">
        <span>ORDERS</span>
      </button>
      }
    </mat-menu>

    <!-- Brand Logo -->
    <div class="logo-section" routerLink="/shop">
      <img class="app-logo" [src]="logoUrl()" [alt]="appName()" />
    </div>

    <!-- Primary Navigation (for all users) -->
    <nav class="primary-nav">
      @for (nav of navigationCategories(); track nav.id) {
      <a routerLink="/shop" [queryParams]="{category: nav.categoryName}" routerLinkActive="active-link">{{
        nav.categoryName | uppercase }}</a>
      }
      @if (navigationCategories().length === 0) {
      <a routerLink="/shop" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">SHOP</a>
      }
      @if (!isAnonymousUser()) {
      <a routerLink="/order-history" routerLinkActive="active-link">ORDERS</a>
      }
    </nav>

    <span class="spacer"></span>

    <!-- Actions Area -->
    <div class="actions-section">
      <!-- Cart Icon with Badge -->
      <button mat-icon-button routerLink="/cart" class="cart-button" aria-label="View Cart">
        <mat-icon [matBadge]="cartItemCount()" [matBadgeHidden]="cartItemCount() === 0" matBadgeColor="warn"
          matBadgeSize="small">
          shopping_cart
        </mat-icon>
      </button>

      <!-- Three Dot Menu (Mobile Only) -->
      @if (isAnonymousUser()) {
      <button mat-icon-button [matMenuTriggerFor]="mobileMenu" class="mobile-menu-button" aria-label="Menu">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #mobileMenu="matMenu">
        <button mat-menu-item (click)="switchToMemberLogin()">
          <mat-icon>swap_horiz</mat-icon>
          <span>Member Login</span>
        </button>
      </mat-menu>
      }

      <!-- Desktop Member Login Button (Hidden on Mobile) -->
      @if (isAnonymousUser()) {
      <button mat-button (click)="switchToMemberLogin()" class="switch-login-button desktop-only"
        title="Switch to Member Login">
        <mat-icon>swap_horiz</mat-icon>
        <span>Member Login</span>
      </button>
      }

      <!-- Logout for member users -->
      @if (isAuthenticated() && !isAnonymousUser()) {
      <button mat-icon-button (click)="logout()" class="logout-button" title="Logout" aria-label="Logout">
        <mat-icon>logout</mat-icon>
      </button>
      }
    </div>
  </div>
</mat-toolbar>